export default __webpack_public_path__ + "static/media/39_1_1.890e325c.png";